import { Navigate, generatePath, useParams } from 'react-router-dom';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { FOOTBALL_PLAY_EVENTTYPE_LEADERBOARD_LEADERBOARD_PRIZE_POOL } from '@sorare/core/src/constants/__generated__/routes';

const LeaderboardPage = () => {
  const { leaderboard = '' } = useParams();
  return (
    <Navigate
      to={generatePath(
        FOOTBALL_PLAY_EVENTTYPE_LEADERBOARD_LEADERBOARD_PRIZE_POOL,
        {
          eventType: So5FixtureEvent.CLASSIC.toLowerCase(),
          leaderboard,
        }
      )}
      replace
    />
  );
};

export default LeaderboardPage;
